import {FC} from 'react'

const SVGIcon: FC<{
    id: string
    width: number
    height: number
    className?: string
    fill?: string
}> = ({id, width, height, className, fill}) => {
    return (
        <svg width={width} height={height} className={className} fill={fill} role="img">
            <use href={`#${id}`} />
        </svg>
    )
}

export default SVGIcon
